import { NAVIGATION_RAIL_DRAWERWIDTH, NAVIGATION_RAIL_LIST_DRAWERWIDTH } from "../../../../../constants/navigationRail.consts.js";
import { DECUPLE, QUINTUPLE } from "../../../../../constants/numbers.consts.js";
export const getMainDrawerInnerSx = ({ expanded }) => ({
    pt: ({ spacing }) => spacing(DECUPLE),
    pb: ({ spacing }) => spacing(QUINTUPLE),
    width: NAVIGATION_RAIL_DRAWERWIDTH,
    transition: ({ transitions }) => transitions.create(["border-right"]),
    borderRight: ({ vars }) => `solid thin ${expanded ? vars.palette.divider : "transparent"}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: ({ spacing }) => spacing(QUINTUPLE),
});
export const listSx = {
    overflowX: "clip",
    overflowY: "auto",
    width: NAVIGATION_RAIL_LIST_DRAWERWIDTH,
    flex: 1,
    scrollbarGutter: "stable both-edges",
    pt: 0,
};
